import React from 'react';
import './css/processo.css';
import { IRepresentante } from '../../modelo/Partes';

interface propsTableRepresentante {
    parteRepresentante: IRepresentante[];
}

class TableRepresentante extends React.Component<propsTableRepresentante> {

    render() {
        return (
            <div>
                {this.props.parteRepresentante?.map(function (rep, index) {
                    let registroComplementar = '';

                    if (rep.registroComplementar) {
                        registroComplementar = ' (' + rep.registroComplementar + ')';
                    }

                    return (
                        <div className="lista-align-left" key={index}>
                            <div className="titulo">
                                {rep.tipo}
                            </div>
                            <div className="lista-align-left">
                                {(rep.nomeSocial || rep.nome) + (registroComplementar)}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }

};

export default TableRepresentante;

